module.exports = __webpack_public_path__ + "static/media/order_confirmed.633c3abb.png";